import {
  CalendarDaysIcon,
  CloudArrowUpIcon,
  ListBulletIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import image from "../../images/client_mockup.png";
import { CheckBadgeIcon } from "@heroicons/react/24/outline";
const features = [
  {
    name: "Nessuna registrazione",
    description:
      "I tuoi clienti non avranno bisogno di nessuna registrazione. Basterà aprire il link del tuo negozio, inserire i propri dati scegliere il giorno in cui venire.",
    icon: ListBulletIcon,
  },
  {
    name: "Calendario e promozioni",
    description:
      "I tuoi clienti potranno scegliere il giorno che preferiscono anche in base alle promozioni offerte da te nelle fasce orarie selezionate",
    icon: CalendarDaysIcon,
  },
  {
    name: "Email di conferma",
    description:
      "I tuoi clienti riceveranno una email di conferma con il riepilogo della loro prenotazione. Pagheranno direttamente nel tuo negozio al termine del servizio",
    icon: CheckBadgeIcon,
  },
];

export function LandingClientFeaturesComponent() {
  return (
    <div id="reservation" className="overflow-hidden bg-white pt-24 sm:pt-48">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-blue-700">
                Prenotazioni semplici e veloci
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                La migliore esperienza utente
              </p>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                GoBarber permette ai tuoi clienti di prenotare in meno di 30
                secondi. Questo significa meno stress per te e i tuoi clienti,
                meno chiamate da gestire e più tempo da dedicare ai tuoi servizi
                per la tua clientela.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        className="absolute left-1 top-1 h-5 w-5 text-blue-900"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src={image}
            alt="Product screenshot"
            className="w-[28rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
    </div>
  );
}
